import styled from "styled-components";

export const WalletWrapper = styled("div")(() => {
  return {
    overflow: "hidden",
    "& h3": {
      marginBlock: 0,
      fontWeight: 600,
      fontSize: "24px",
    },
    "& .cards-group": {
      "@media screen and (max-width: 768px)": {
        flexDirection: "column",
      },
    },
    "& .wallet-balance-card": {
      background: "#FFF",
      boxShadow: "0 8px 24px -4px var(--color-button-secondary)",
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "translateY(-4px)",
      },
      "& .card-title": {
        color: "var(--color-text-light)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        letterSpacing: "1.6px",
        textTransform: "uppercase",
      },
      "& .card-body": {
        paddingTop: "2rem",
        "& p": {
          color: "var(--color-text)",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "28px",
          "& span": {
            color: "var(--color-primary)",
            fontSize: "clamp(2.5rem, 5vw, 3.75rem)",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "60px",
          },
        },
        "& .fund-button": {
          backgroundColor: "var(--color-primary)",
          color: "#FFFFFF",
          border: "none",
          borderRadius: "0.5rem",
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          fontWeight: 600,
          fontFamily: "Poppins",
          cursor: "pointer",
          transition: "background-color 0.2s ease",
          "&:hover": {
            backgroundColor: "#246b28",
          },
        },
      },
      "& .card-body-introduction": {
        padding: "calc(var(--cardPadding)/2) 0",
        p: {
          fontWeight: 700,
          fontSize: "16px",
        },
      },
      "& p": {
        marginBlock: 0,
      },
    },
    "& .wallet-fund-card": {
      background: "#FFF",
      boxShadow: "0 8px 24px -4px var(--color-button-secondary)",
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "translateY(-4px)",
      },
      "& .card-title": {
        color: "var(--color-text-light)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        letterSpacing: "1.6px",
        textTransform: "uppercase",
      },
      "& .card-body": {
        paddingTop: "2rem",
        "& p": {
          color: "var(--color-text-light)",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "22px",
          marginBottom: "1.5rem",
        },
      },
      "& .card-body-introduction": {
        padding: "calc(var(--cardPadding)/2) 0",
        p: {
          fontWeight: 700,
          fontSize: "16px",
        },
      },
      "& p": {
        marginBlock: 0,
      },
    },
  };
});
